import { Utilities } from "@utils/utilities";
import { useEffect, useState } from "react";
import {
  DataTableData,
  DataTableDataCellValue,
  DataTableDataJSXElement,
  DataTableHeader,
  DataTableRawStringElement,
  isDataTableV2Element,
} from "./DataTable";

type DataTableCellProps = {
  data: DataTableData;
  header: DataTableHeader;
  draggable?: boolean;
  dataCy?: string;
};

/**
 * @deprecated use Table2 instead
 */
export const DataTableCell = (props: DataTableCellProps) => {
  const [value, setValue] = useState<string | JSX.Element | JSX.Element[]>("");
  useEffect(() => {
    const processData = async (element: DataTableDataCellValue | Promise<DataTableDataCellValue>) => {
      if (element === undefined || element === "") {
        setValue("");
      } else if (element instanceof Date) {
        setValue(Utilities.formatDateTime(element));
      } else if (typeof element === "string" || typeof element === "number") {
        let val = element.toString();
        if (val.length > 50) val = val.substring(0, 50) + "...";
        setValue(val + (props.header.suffix ? " (" + props.header.suffix + ")" : ""));
      } else if (element instanceof Promise) {
        element.then((val) => {
          processData(val);
        });
      } else if (isDataTableV2Element(element)) {
        if (element.loader) await element.loader();
        processData(element.cellValue());
      } else if ((element as DataTableDataJSXElement) && (element as DataTableDataJSXElement)?.element) {
        setValue((element as DataTableDataJSXElement).element);
      } else if ((element as DataTableRawStringElement) && (element as DataTableRawStringElement)?.displayString) {
        setValue((element as DataTableRawStringElement).displayString);
      }
    };
    if (Object.keys(props.data.cells).includes(props.header.key)) {
      processData(props.data.cells[props.header.key]);
    } else {
      setValue("");
    }
  }, [props.data, props.header]);
  return (
    <td style={props.draggable ? { width: "20%" } : {}} data-cy={`${props.dataCy}-item-${props.header.key}-${props.data.cells.title}`}>
      {value}
    </td>
  );
};

